// Mock data pour le Centre Linguistique Russe du Cameroun

export const centerInfo = {
  name: "Centre Linguistique Russe du Cameroun",
  nameRu: "Русский Лингвистический Центр Камеруна",
  phone: "+237 6 93 27 07 00",
  email: "centrelinguistiquerusseducmr@gmail.com",
  address: "Douala, Bonapriso rue Koloko, Cameroun",
  rating: 4.99,
  reviewCount: 127,
  hours: {
    monday: "08:00 - 17:30",
    tuesday: "08:00 - 17:30",
    wednesday: "08:00 - 17:30",
    thursday: "08:00 - 17:30",
    friday: "08:00 - 17:30",
    saturday: "09:00 - 15:00",
    sunday: "Fermé"
  }
};

export const courses = [
  {
    id: 1,
    title: "Russe Débutant A1",
    titleRu: "Начальный уровень А1",
    description: "Idéal pour les étudiants qui commencent à apprendre le russe. Apprenez l'alphabet cyrillique, les bases de la grammaire et les phrases essentielles.",
    duration: "3 mois",
    schedule: "Lundi, Mercredi, Vendredi - 17:00-19:00",
    level: "Débutant",
    students: 45,
    category: "Russe"
  },
  {
    id: 2,
    title: "Russe Élémentaire A2",
    titleRu: "Элементарный уровень А2",
    description: "Développez vos compétences en conversation et approfondissez votre compréhension de la grammaire russe.",
    duration: "4 mois",
    schedule: "Mardi, Jeudi - 17:00-19:30",
    level: "Élémentaire",
    students: 38,
    category: "Russe"
  },
  {
    id: 3,
    title: "Russe Intermédiaire B1",
    titleRu: "Средний уровень B1",
    description: "Perfectionnez votre maîtrise de la langue russe avec des discussions avancées et une grammaire complexe.",
    duration: "5 mois",
    schedule: "Lundi, Mercredi - 19:00-21:00",
    level: "Intermédiaire",
    students: 28,
    category: "Russe"
  },
  {
    id: 4,
    title: "Russe Avancé B2-C1",
    titleRu: "Продвинутый уровень B2-C1",
    description: "Atteignez la maîtrise complète avec la littérature russe, les affaires et la communication professionnelle.",
    duration: "6 mois",
    schedule: "Samedi - 09:00-13:00",
    level: "Avancé",
    students: 15,
    category: "Russe"
  },
  {
    id: 5,
    title: "Russe des Affaires",
    titleRu: "Деловой русский",
    description: "Cours spécialisé pour les professionnels qui souhaitent communiquer en russe dans un contexte commercial.",
    duration: "4 mois",
    schedule: "Mardi, Jeudi - 19:00-21:00",
    level: "Intermédiaire+",
    students: 12,
    category: "Russe"
  },
  {
    id: 6,
    title: "Préparation TORFL",
    titleRu: "Подготовка к ТРКИ",
    description: "Préparation intensive aux examens officiels de certification en langue russe (TORFL/ТРКИ).",
    duration: "3 mois",
    schedule: "Mercredi, Vendredi - 19:00-21:00",
    level: "Tous niveaux",
    students: 20,
    category: "Russe"
  },
  {
    id: 7,
    title: "Anglais Débutant A1",
    titleEn: "Beginner Level A1",
    description: "Commencez votre apprentissage de l'anglais avec les fondamentaux: alphabet, grammaire de base et vocabulaire essentiel.",
    duration: "3 mois",
    schedule: "Lundi, Mercredi - 15:00-17:00",
    level: "Débutant",
    students: 52,
    category: "Anglais"
  },
  {
    id: 8,
    title: "Anglais Intermédiaire B1",
    titleEn: "Intermediate Level B1",
    description: "Améliorez votre anglais conversationnel et développez vos compétences en communication écrite et orale.",
    duration: "4 mois",
    schedule: "Mardi, Jeudi - 15:00-17:00",
    level: "Intermédiaire",
    students: 48,
    category: "Anglais"
  },
  {
    id: 9,
    title: "Anglais Avancé B2-C1",
    titleEn: "Advanced Level B2-C1",
    description: "Perfectionnez votre maîtrise de l'anglais pour un usage académique et professionnel avancé.",
    duration: "5 mois",
    schedule: "Mercredi, Vendredi - 15:00-17:30",
    level: "Avancé",
    students: 35,
    category: "Anglais"
  },
  {
    id: 10,
    title: "Anglais des Affaires",
    titleEn: "Business English",
    description: "Cours spécialisé pour les professionnels souhaitant communiquer efficacement en anglais dans le monde des affaires.",
    duration: "4 mois",
    schedule: "Lundi, Mercredi - 18:00-20:00",
    level: "Intermédiaire+",
    students: 30,
    category: "Anglais"
  },
  {
    id: 11,
    title: "Préparation TOEFL/IELTS",
    titleEn: "TOEFL/IELTS Preparation",
    description: "Préparation intensive aux examens internationaux TOEFL et IELTS pour vos études à l'étranger.",
    duration: "3 mois",
    schedule: "Samedi - 14:00-17:00",
    level: "Tous niveaux",
    students: 42,
    category: "Anglais"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Kamga",
    course: "Russe Intermédiaire B1",
    text: "Le Centre Linguistique Russe m'a permis de réaliser mon rêve d'étudier en Russie. Les professeurs sont exceptionnels et très patients!",
    rating: 5,
    year: 2024
  },
  {
    id: 2,
    name: "Jean-Paul Mbida",
    course: "Russe des Affaires",
    text: "Formation de qualité supérieure! J'ai pu décrocher un contrat avec une entreprise russe grâce à mes compétences linguistiques.",
    rating: 5,
    year: 2024
  },
  {
    id: 3,
    name: "Sandrine Tchamba",
    course: "Russe Débutant A1",
    text: "Excellente méthode d'enseignement. En 3 mois, je peux déjà tenir des conversations simples en russe!",
    rating: 5,
    year: 2023
  },
  {
    id: 4,
    name: "Boris Ngono",
    course: "Préparation TORFL",
    text: "J'ai réussi mon examen TORFL B2 du premier coup grâce à la préparation intensive du centre. Merci infiniment!",
    rating: 5,
    year: 2023
  }
];

export const features = [
  {
    title: "Professeurs Qualifiés",
    titleRu: "Квалифицированные преподаватели",
    description: "Enseignants natifs et certifiés avec une expérience internationale"
  },
  {
    title: "Méthode Moderne",
    titleRu: "Современные методы",
    description: "Approche communicative et interactive pour un apprentissage rapide"
  },
  {
    title: "Petites Classes",
    titleRu: "Малые группы",
    description: "Maximum 15 étudiants par classe pour un suivi personnalisé"
  },
  {
    title: "Certification Officielle",
    titleRu: "Официальная сертификация",
    description: "Préparation aux examens TORFL reconnus internationalement"
  },
  {
    title: "Horaires Flexibles",
    titleRu: "Гибкий график",
    description: "Cours en journée, soirée et weekend adaptés à votre emploi du temps"
  },
  {
    title: "Support Culturel",
    titleRu: "Культурная поддержка",
    description: "Activités culturelles et aide pour les études en Russie"
  }
];

export const stats = [
  { number: "500+", label: "Étudiants Formés" },
  { number: "12+", label: "Années d'Expérience" },
  { number: "8", label: "Professeurs Experts" },
  { number: "98%", label: "Taux de Réussite" }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_36ca76af-f26c-4a30-8708-0155b7b3f7ff/artifacts/4p0oany2_2023-07-21%20%281%29.webp",
    caption: "Session de formation",
    category: "classes"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_36ca76af-f26c-4a30-8708-0155b7b3f7ff/artifacts/fib7dyyo_2023-07-21.webp",
    caption: "Notre Centre à Douala",
    category: "facility"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_36ca76af-f26c-4a30-8708-0155b7b3f7ff/artifacts/k4202270_2023-07-23.webp",
    caption: "Cours en classe",
    category: "classes"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_36ca76af-f26c-4a30-8708-0155b7b3f7ff/artifacts/9cdyll4u_2024-06-18%20%281%29.webp",
    caption: "Nos étudiants diplômés",
    category: "students"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_36ca76af-f26c-4a30-8708-0155b7b3f7ff/artifacts/fmjakpxu_2024-06-18%20%282%29.webp",
    caption: "Espace d'accueil",
    category: "facility"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/kgrzhxne_2024-06-18%20%288%29.webp",
    caption: "Célébration avec nos étudiants",
    category: "students"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/99fu5x44_2024-06-18%20%283%29.webp",
    caption: "Journée culturelle internationale",
    category: "students"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/6c9lljc7_2024-06-18%20%2810%29.webp",
    caption: "Cérémonie de remise de diplômes",
    category: "students"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/7k5lh5v3_unnamed.webp",
    caption: "Bureau administratif",
    category: "facility"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/t7qtaxuw_2024-06-18%20%286%29.webp",
    caption: "Cérémonie de graduation",
    category: "students"
  },
  {
    id: 11,
    url: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/x89yh23a_unnamed%20%282%29.webp",
    caption: "Façade du Centre Linguistique",
    category: "facility"
  },
  {
    id: 12,
    url: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/2vkj253o_unnamed%20%283%29.webp",
    caption: "Bureau de consultation",
    category: "facility"
  },
  {
    id: 13,
    url: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/9hbdikcm_unnamed%20%284%29.webp",
    caption: "Espace administratif",
    category: "facility"
  },
  {
    id: 14,
    url: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/5lffwd26_2024-06-18%20%2811%29.webp",
    caption: "Véhicule officiel du Centre",
    category: "facility"
  },
  {
    id: 15,
    url: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/uub37jbt_2024-06-18%20%285%29.webp",
    caption: "Session de cours avec professeur natif",
    category: "classes"
  }
];

export const faqs = [
  {
    question: "Combien de temps faut-il pour apprendre le russe?",
    answer: "Cela dépend de votre niveau cible. Pour atteindre un niveau de conversation de base (A2), il faut généralement 6-8 mois avec 3 cours par semaine. Pour un niveau avancé (B2), comptez 18-24 mois."
  },
  {
    question: "Dois-je connaître l'alphabet cyrillique avant de commencer?",
    answer: "Non, notre cours débutant A1 commence par l'apprentissage de l'alphabet cyrillique. Nous vous guidons pas à pas depuis les bases."
  },
  {
    question: "Proposez-vous des cours en ligne?",
    answer: "Oui, nous offrons des cours en ligne via Zoom pour les étudiants qui ne peuvent pas se déplacer. Le contenu et la qualité sont identiques aux cours en présentiel."
  },
  {
    question: "Aidez-vous pour les démarches d'études en Russie?",
    answer: "Absolument! Nous assistons nos étudiants dans leurs démarches pour étudier en Russie, incluant le choix de l'université, les documents et la préparation culturelle."
  },
  {
    question: "Les certificats sont-ils reconnus internationalement?",
    answer: "Oui, nous préparons aux examens TORFL (ТРКИ) qui sont officiellement reconnus par le gouvernement russe et acceptés par toutes les universités russes et employeurs internationaux."
  },
  {
    question: "Puis-je essayer un cours avant de m'inscrire?",
    answer: "Oui! Nous offrons un cours d'essai gratuit. Contactez-nous pour réserver votre session découverte."
  }
];

export const aboutInfo = {
  mission: "Le Centre Linguistique Russe du Cameroun s'engage à fournir une éducation de qualité en langue russe, facilitant les échanges culturels et académiques entre le Cameroun, la Russie, l'Inde et tous les autres pays partenaires du BRICS.",
  vision: "Devenir le centre de référence pour l'apprentissage de la langue russe en Afrique Centrale, en préparant nos étudiants à exceller dans leurs études et carrières internationales mais aussi l'accompagnement et l'orientation des étudiants dans leurs cursus à travers des universités partenaires dans le monde, notamment la Russie, l'Inde, la Chine, Singapore et bien d'autres...",
  values: [
    "Excellence pédagogique",
    "Respect des cultures",
    "Innovation dans l'enseignement",
    "Accompagnement personnalisé"
  ],
  history: "Fondé en 2023, le Centre Linguistique Russe du Cameroun a formé et accompagné plus de 500 étudiants qui poursuivent maintenant des études ou des carrières réussies en Russie, en Inde et à l'international. Notre équipe de professeurs expérimentés combine des méthodes d'enseignement modernes avec une compréhension profonde de la culture russe."
};

export const bricsCountries = [
  {
    id: 1,
    name: "Russie",
    nameEn: "Russia",
    flag: "🇷🇺",
    color: "#0039A6",
    universities: 45,
    students: 280,
    description: "Leader mondial en sciences, ingénierie et médecine"
  },
  {
    id: 2,
    name: "Inde",
    nameEn: "India",
    flag: "🇮🇳",
    color: "#FF9933",
    universities: 32,
    students: 120,
    description: "Excellence en IT, management et technologies de pointe"
  },
  {
    id: 3,
    name: "Chine",
    nameEn: "China",
    flag: "🇨🇳",
    color: "#DE2910",
    universities: 28,
    students: 85,
    description: "Innovation technologique et programmes d'ingénierie avancés"
  },
  {
    id: 4,
    name: "Singapore",
    nameEn: "Singapore",
    flag: "🇸🇬",
    color: "#EF3340",
    universities: 8,
    students: 35,
    description: "Hub asiatique pour business, finance et tech"
  },
  {
    id: 5,
    name: "Brésil",
    nameEn: "Brazil",
    flag: "🇧🇷",
    color: "#009739",
    universities: 15,
    students: 25,
    description: "Excellence en agriculture, environnement et sciences sociales"
  },
  {
    id: 6,
    name: "Afrique du Sud",
    nameEn: "South Africa",
    flag: "🇿🇦",
    color: "#007A4D",
    universities: 12,
    students: 18,
    description: "Leader africain en recherche et développement"
  }
];

export const partnerUniversities = [
  // Russie
  {
    id: 1,
    name: "Université d'État de Moscou (MGU)",
    country: "Russie",
    city: "Moscou",
    ranking: "Top 100 mondial",
    specialties: ["Sciences", "Mathématiques", "Physique", "Médecine"],
    scholarships: true,
    tuitionFree: true
  },
  {
    id: 2,
    name: "Université Technique d'État de Bauman",
    country: "Russie",
    city: "Moscou",
    ranking: "Top 5 en ingénierie",
    specialties: ["Ingénierie mécanique", "Aérospatiale", "Robotique"],
    scholarships: true,
    tuitionFree: true
  },
  {
    id: 3,
    name: "Université d'État de Saint-Pétersbourg",
    country: "Russie",
    city: "Saint-Pétersbourg",
    ranking: "Top 250 mondial",
    specialties: ["Langues", "Histoire", "Relations Internationales"],
    scholarships: true,
    tuitionFree: true
  },
  {
    id: 4,
    name: "Université Russe de l'Amitié des Peuples (RUDN)",
    country: "Russie",
    city: "Moscou",
    ranking: "Top 400 mondial",
    specialties: ["Médecine", "Ingénierie", "Sciences Humaines", "Économie"],
    scholarships: true,
    tuitionFree: true,
    featured: true,
    description: "Université internationale accueillant plus de 30 000 étudiants de 160 pays"
  },
  // Inde
  {
    id: 5,
    name: "Acharya University",
    country: "Inde",
    city: "Bangalore",
    ranking: "Top université privée Inde",
    specialties: ["Engineering", "Business Management", "Computer Science", "Architecture"],
    scholarships: true,
    tuitionFree: false,
    featured: true,
    description: "Université moderne de Bangalore avec campus high-tech et forte orientation internationale"
  },
  {
    id: 6,
    name: "Indian Institute of Technology (IIT) Delhi",
    country: "Inde",
    city: "New Delhi",
    ranking: "Top 50 en ingénierie",
    specialties: ["Computer Science", "IA", "Data Science"],
    scholarships: true,
    tuitionFree: false
  },
  {
    id: 7,
    name: "All India Institute of Medical Sciences",
    country: "Inde",
    city: "New Delhi",
    ranking: "Top 1 médecine Inde",
    specialties: ["Médecine", "Chirurgie", "Recherche médicale"],
    scholarships: true,
    tuitionFree: false
  },
  // Chine
  {
    id: 8,
    name: "Tsinghua University",
    country: "Chine",
    city: "Beijing",
    ranking: "Top 20 mondial",
    specialties: ["Engineering", "Computer Science", "Business"],
    scholarships: true,
    tuitionFree: false
  },
  {
    id: 9,
    name: "Peking University",
    country: "Chine",
    city: "Beijing",
    ranking: "Top 30 mondial",
    specialties: ["Sciences", "Humanities", "Social Sciences"],
    scholarships: true,
    tuitionFree: false
  },
  // Singapore
  {
    id: 10,
    name: "National University of Singapore (NUS)",
    country: "Singapore",
    city: "Singapore",
    ranking: "Top 15 mondial",
    specialties: ["Business", "Engineering", "Computer Science"],
    scholarships: true,
    tuitionFree: false
  }
];

export const studentTestimonials = [
  {
    id: 1,
    name: "Jean-Baptiste Nkomo",
    program: "Ingénierie Mécanique",
    university: "Université Technique d'État de Bauman",
    country: "Russie",
    city: "Moscou",
    year: 2024,
    image: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/kgrzhxne_2024-06-18%20%288%29.webp",
    quote: "Grâce au Centre Linguistique, j'ai obtenu une bourse complète pour étudier l'ingénierie en Russie. Le soutien a été exceptionnel, de la préparation linguistique à l'obtention du visa!",
    currentStatus: "2ème année"
  },
  {
    id: 2,
    name: "Grace Mbella",
    program: "Médecine",
    university: "Université d'État de Moscou",
    country: "Russie",
    city: "Moscou",
    year: 2023,
    image: "https://customer-assets.emergentagent.com/job_36ca76af-f26c-4a30-8708-0155b7b3f7ff/artifacts/9cdyll4u_2024-06-18%20%281%29.webp",
    quote: "L'équipe m'a accompagnée à chaque étape. Aujourd'hui, je réalise mon rêve d'être médecin dans l'une des meilleures universités du monde!",
    currentStatus: "3ème année"
  },
  {
    id: 3,
    name: "Patrick Fosso",
    program: "Computer Science & AI",
    university: "IIT Delhi",
    country: "Inde",
    city: "New Delhi",
    year: 2024,
    image: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/99fu5x44_2024-06-18%20%283%29.webp",
    quote: "J'étudie maintenant à l'IIT Delhi grâce à l'orientation professionnelle du centre. Le niveau est exceptionnel et les opportunités infinies!",
    currentStatus: "1ère année"
  },
  {
    id: 4,
    name: "Sandra Tchuente",
    program: "Business Administration",
    university: "National University of Singapore",
    country: "Singapore",
    city: "Singapore",
    year: 2023,
    image: "https://customer-assets.emergentagent.com/job_russian-language-hub/artifacts/6c9lljc7_2024-06-18%20%2810%29.webp",
    quote: "Singapore était mon rêve, et le centre l'a rendu possible. Les cours d'anglais m'ont parfaitement préparée pour mes études en business à NUS!",
    currentStatus: "Diplômée 2024"
  }
];

export const admissionProcess = [
  {
    step: 1,
    title: "Consultation Initiale",
    description: "Rencontrez nos conseillers pour discuter de vos objectifs académiques et choisir le meilleur pays/université.",
    duration: "1 semaine"
  },
  {
    step: 2,
    title: "Formation Linguistique",
    description: "Suivez nos cours de russe ou d'anglais selon votre destination pour atteindre le niveau requis.",
    duration: "3-6 mois"
  },
  {
    step: 3,
    title: "Préparation du Dossier",
    description: "Notre équipe vous aide à constituer un dossier complet et compétitif pour les universités.",
    duration: "2-4 semaines"
  },
  {
    step: 4,
    title: "Demande de Bourse",
    description: "Nous vous assistons dans les démarches pour obtenir des bourses gouvernementales ou universitaires.",
    duration: "1-2 mois"
  },
  {
    step: 5,
    title: "Obtention du Visa",
    description: "Accompagnement complet pour toutes les démarches d'obtention de visa étudiant.",
    duration: "1-2 mois"
  },
  {
    step: 6,
    title: "Départ & Suivi",
    description: "Préparation au départ et suivi continu pendant vos études à l'étranger.",
    duration: "Continu"
  }
];

export const scholarshipStats = {
  totalStudents: 500,
  studentsAbroad: 320,
  scholarshipsObtained: 285,
  successRate: 92,
  countries: 15
};
